import { CONTAIN_LETTERS_AND_NUMBERS, MIN_PASSWORD_LENGTH, MAX_PASSWORD_LENGTH } from "@/constants/form";

function isValidPassword(password) {
    return password?.length >= MIN_PASSWORD_LENGTH
        && password?.length <= MAX_PASSWORD_LENGTH
        && password.match(CONTAIN_LETTERS_AND_NUMBERS)
}

export { isValidPassword }